export const GET_ENTRIES_AND_DEPARTURES = 'GET_ENTRIES_AND_DEPARTURES';
export const SET_FILTERS = 'SET_FILTERS';
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const SET_TABLE_HEADERS = 'SET_TABLE_HEADERS';
export const SET_PAGE = 'SET_PAGE';
export const SET_RESOURCE_DETAIL = 'SET_RESOURCE_DETAIL';
export const SET_CHANGE_FETCHING = 'SET_CHANGE_FETCHING';
export const SET_ERROR = 'SET_ERROR';
export const CLEAN_FILTERS = 'CLEAN_FILTERS';
export const DOWNLOAD_ENTRY_AND_DEPARTURE_REPORT = 'DOWNLOAD_ENTRY_AND_DEPARTURE_REPORT';
export const EDIT_ENTRY_OR_DEPARTURE = 'EDIT_ENTRY_OR_DEPARTURE';
export const DOWNLOADING = 'DOWNLOADING';